export const environment = {
  production: true,
  apiUrlx: '/assets/api/data.json',
  // apiUrl: 'https://fonzi-be-api-development.herokuapp.com/api/data?currency=eur'
  // apiUrl: 'https://fonzi-be-api-production.herokuapp.com/api/data?currency=eur'
  apiUrl: 'http://xzzs5v5rerdzn6ye5.stoplight-proxy.io/api/data2'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts